//
// Sessions
// ================================================================================

function sessions() {

    const sessionsContainer = document.querySelector('.c-session-list__list');
    const allSessions = [...document.querySelectorAll('[data-session]')];

    // Set eventListener
    allSessions.forEach(session => {

        session.addEventListener('click', () => {

            if (!session.classList.contains('--is-active')) {

                let sessionScreenings = session.querySelector('.c-session__screenings');
                let screeningsHeight;

                // Check if there are tabs
                if (sessionScreenings.getAttribute('data-tabs') == 'true') {

                    // Find the tabs and panels areas height
                    // Panels area height is set on tabs.js based on highest tab pane
                    const tabsHeight = session.querySelector('.c-session__days').offsetHeight;
                    const panesHeight = session.querySelector('.c-session__panels').offsetHeight;
                    screeningsHeight = tabsHeight + panesHeight;

                // If there aren't tabs...
                } else {
                    screeningsHeight = sessionScreenings.scrollHeight;
                }

                // If there is an active session, deactivate it
                let activeSession = sessionsContainer.querySelector('[data-session].--is-active');
                if (activeSession) {
                    let activeSessionScreenings = activeSession.querySelector('.c-session__screenings');
                    activeSessionScreenings.style.height = '0px';
                    activeSession.classList.remove('--is-active');
                }

                // Activate and set height
                session.classList.add('--is-active');
                sessionScreenings.style.height = screeningsHeight + 'px';
            }
        })
    });

}

export { sessions }
